// extracted by mini-css-extract-plugin
export default {"header":"ConfirmModal_header__8o+B2","title":"ConfirmModal_title__vT0sW","body":"ConfirmModal_body__3d5ZP","button":"ConfirmModal_button__b0VE8"};